import { render, staticRenderFns } from "./AutorizacionDeclaraciones.vue?vue&type=template&id=24cb73c4&"
import script from "./AutorizacionDeclaraciones.vue?vue&type=script&lang=js&"
export * from "./AutorizacionDeclaraciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports